import React from 'react';
import { Select, FormControl } from '@material-ui/core';
import { CategoryDetails } from 'store/categoryStore/reducer';
import { useStyles } from '../OrderDetails/styles';
import { Positions } from 'constants/enums';

type Props = {
    workAreas: CategoryDetails[] | undefined;
    selectedWorkAreas?: CategoryDetails[] | undefined;
    handleCategory: (category: CategoryDetails) => void;
};

export const allItem = {
    id: 'all',
    name: 'All Areas',
    isDisabled: false,
    position: Positions.COOK,
} as CategoryDetails;

function WorkAreaSelector({ workAreas, handleCategory, selectedWorkAreas }: Props) {
    return (
        <FormControl style={styles.form}>
            <Select
                labelId="dropdown-label"
                id="dropdown"
                multiple
                value={selectedWorkAreas?.map((area) => area.id) || []}
                style={styles.select as React.CSSProperties}
                renderValue={() => (
                    <span style={styles.label}>
                        {selectedWorkAreas?.length === (workAreas?.length || 0) + 1
                            ? 'All areas'
                            : selectedWorkAreas?.map((area) => area.name).join(', ')}
                    </span>
                )}
                MenuProps={{
                    classes: { paper: 'dropdown-menu' },
                    style: styles.menu,
                }}
            >
                <div>
                    {[allItem, ...(workAreas || [])]?.map((item) => {
                        return (
                            <CustomMenuItem
                                key={item.id}
                                item={item}
                                chooseCategory={handleCategory}
                                checked={
                                    selectedWorkAreas?.some((area) => area.id === item.id) || false
                                }
                            />
                        );
                    })}
                </div>
            </Select>
        </FormControl>
    );
}

const CustomMenuItem = ({
    item,
    chooseCategory,
    checked,
}: {
    item: any;
    chooseCategory: (category: CategoryDetails) => void;
    checked: boolean;
}) => {
    const classes = useStyles();
    return (
        <div
            className={classes.orderDetailsHeadingBackground}
            style={{
                ...styles.categoryNameContainer,
                backgroundColor: checked ? '#99567E' : 'transparent',
                color: checked ? '#fff' : '#592A46',
            }}
            onClick={() => chooseCategory(item)}
            key={item.id}
        >
            <span style={styles.categoryNameText as React.CSSProperties}>{item.name}</span>
        </div>
    );
};

const styles = {
    form: {
        width: '172px',
    },
    label: {
        color: '#99567E',
        fontSize: 16,
        fontWeight: 700,
        paddingLeft: 8,
    },
    select: {
        border: '1px solid #99567E',
        borderRadius: '100px',
        marginLeft: '8px',
        marginRight: '8px',
        overflow: 'hidden',
        textAlign: 'center',
    },
    menu: {
        borderRadius: '5px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        marginTop: 50,
        width: '172px',
        alignItems: 'center',
    },
    item: {
        width: '132px',
        alignItems: 'center',
        borderBottom: 0,
        border: '1px solid #99567E',
        borderRadius: '100px',
        height: '20px',
        marginTop: '8px',
        marginBottom: '8px',
        marginLeft: 16,
        color: '#99567E',
    },
    selectedItem: {
        backgroundColor: '#99567E',
        color: '#fff',
    },
    categoryNameContainer: {
        border: `1px solid grey`,
        width: 128,
        marginTop: 10,
        marginLeft: 12,
    },
    categoryNameText: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
};

export default WorkAreaSelector;
